import { render, staticRenderFns } from "./trustFromWindow.vue?vue&type=template&id=b72c7848&"
import script from "./trustFromWindow.vue?vue&type=script&lang=js&"
export * from "./trustFromWindow.vue?vue&type=script&lang=js&"
import style0 from "./trustFromWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b72c7848')) {
      api.createRecord('b72c7848', component.options)
    } else {
      api.reload('b72c7848', component.options)
    }
    module.hot.accept("./trustFromWindow.vue?vue&type=template&id=b72c7848&", function () {
      api.rerender('b72c7848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/trustFromWindow.vue"
export default component.exports